import { useEffect, useRef, useState } from 'react'

/**
 * True while the scroll container is actively scrolling; false after idleMs of no scroll events.
 */
export function useScrollIdle(scrollRef, options = {}) {
  const { enabled = true, idleMs = 180 } = options
  const [isScrolling, setIsScrolling] = useState(false)
  const timeoutRef = useRef(null)

  useEffect(() => {
    if (!enabled) {
      setIsScrolling(false)
      return undefined
    }

    const el = scrollRef?.current
    if (!el) return undefined

    const handleScroll = () => {
      setIsScrolling(true)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        setIsScrolling(false)
      }, idleMs)
    }

    el.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      el.removeEventListener('scroll', handleScroll)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [enabled, idleMs, scrollRef])

  return isScrolling
}
